import * as MD from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import styled from 'styled-components';
import { withTheme } from '@material-ui/styles';
import '@yacast/react-player/dist/index.css';

// Material components
import MuiDialogTitle from '@material-ui/core/DialogTitle';

import MuiTablePagination from '@material-ui/core/TablePagination';
import {
  ButtonDense,
  ButtonDenseNoColor,
  CustomTooltip,
  StyledLink,
} from '../../Themes/StyledElements';

//Store
import { IApplicationState } from '../../Store';
import { I18N, ILocaleInfos } from '../../Store/I18n/Types';
import { getTheme } from '../../Themes';

//Icons
import AddIcon from '@material-ui/icons/Add';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import DoneOutlineIcon from '@material-ui/icons/DoneOutline';
import EditIcon from '@material-ui/icons/Edit';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import LastPageIcon from '@material-ui/icons/LastPage';
import GetAppIcon from '@material-ui/icons/GetApp';
import VideocamIcon from '@material-ui/icons/Videocam';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';

import Moment from 'moment';

// Material components
import { IconButton } from '@material-ui/core';
import MuiTableCell from '@material-ui/core/TableCell';

// Date Pickers
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { enGB, fr, de } from 'date-fns/locale';
import {
  ISpotDetailsState,
  IFingerprintBucketPair,
  IReportSpotDetails,
  IPaginationParams,
} from '../../Store/SpotDetails/Types';
import { IOrderValue, ISearchState } from '../../Store/Search/Types';
import {
  getSpotDetails,
  getBroadcastsPassages,
  downloadCSV,
  reportSpotProblem,
  getBroadcastWebPassages,
  getBroadcastsPassagesByFgpID,
  getSpotFormulaires,
} from '../../Store/SpotDetails/Actions';
import { getFormulairePreview } from '../../Store/Formulaire/Actions';
import {
  IFormulaireFranceState,
  IFormulaireGemaState,
} from '../../Store/Formulaire/Types';
import withStyles, { WithStyles } from '@material-ui/styles/withStyles';
import {
  hasPermissionExportPassages,
  hasPermissionMediaPassagesToRead,
} from '../../Utils/Rights';
import { IUserState } from '../../Store/User/Types';
import { RouteComponentProps } from 'react-router-dom';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import { ILayoutState } from '../../Store/Layout/Types';
import { isNullOrUndefined } from '../../Utils/Various';
import { PaperComponent } from '../HelpFunction';
import { PlayerMaster } from '../PlayerMaster';
import { Config } from '../../config';
import styles from './Content.style';
import { getAdvertisementRadio } from '../../Store/AdvertisementRadio/Actions';
import {
  AdRadio,
  AdvertisementRadioResult,
  GroupAdRadio,
  IAdvertisementRadio,
  TrackRadio,
} from '../../Store/AdvertisementRadio/Types';
import { getBroadcast, getCSV } from '../../Store/Broadcast/Actions';
import {
  BroadcastMedia,
  BroadcastPayload,
  BroadcastResponse,
  BroadcastResult,
  IBroadcast,
} from '../../Store/Broadcast/Types';
import { MaterialUiPickersDate } from 'material-ui-pickers/typings/date';
import Alert from '@material-ui/lab/Alert';
import {
  IDeclarationStatus,
  ResponseDeclarationStatus,
} from '../../Store/DeclarationStatus/Types';
import { getDeclarationStatus } from '../../Store/DeclarationStatus/Actions';

const theme = getTheme();

interface RouteParams {
  bucket: string;
  fgpid: string;
}

interface IPropsFromState {
  i18n: I18N;
  localeInfos: ILocaleInfos;
  search: ISearchState;
  spotDetails: ISpotDetailsState;
  user: IUserState;
  router: RouteComponentProps<RouteParams>;
  layout: ILayoutState;
  advertisementRadio: IAdvertisementRadio;
  broadcast: IBroadcast;
  declarationStatus: IDeclarationStatus;
}

const order_params: IPaginationParams = {
  page_size: 100,
  page: 1,
  order_by: [
    {
      field: 'start_date',
      value: 'desc',
    },
  ],
};
interface IPropsFromDispatch {
  downloadCSV: typeof downloadCSV;
  getBroadcastsPassages: typeof getBroadcastsPassages;
  getBroadcastsPassagesByFgpID: typeof getBroadcastsPassagesByFgpID;
  getBroadcastWebPassages: typeof getBroadcastWebPassages;
  getFormulairePreview: typeof getFormulairePreview;
  getSpotDetails: typeof getSpotDetails;
  getSpotFormulaires: typeof getSpotFormulaires;
  reportSpotProblem: typeof reportSpotProblem;
  getAdvertisementRadio: typeof getAdvertisementRadio;
  getBroadcast: typeof getBroadcast;
  getCSV: typeof getCSV;
  getDeclarationStatus: typeof getDeclarationStatus;
}

interface DetailsComponentProps {
  regroupingId: string;
  fgpId: number;
  bucketId: number;
}

type AllProps = WithStyles<typeof styles> &
  IPropsFromState &
  DetailsComponentProps &
  IPropsFromDispatch &
  RouteComponentProps<RouteParams>;

interface IMediaListItem {
  id: number;
  label: string;
}

interface IState {
  regions: any;
  selectedIndex: number;
  selectedMaster: any;
  selectedId: number;
  idPlaying: number;
  mbAudioInfos: any[];
  currentTime: any;
  duration: any;
  progress: any;
  playbackStatus: any;
  isSeeking: boolean;
  isLoading: boolean;
  currentPage: number;
  endDate: Date | null;
  passages: any[];
  perPage: number;
  searchInput: string | null;
  selectedMediaFilter: number;
  selectedSupportTypeFilter: number;
  startDate: Date | null;
  openDialogDownloadCSV: boolean;
  totalCount: number;
  totalPages: number;
  openReportDialog: boolean;
  senderEmail: string;
  emailError: string;
  reportComment: string;
  broadcastPlaying: any;
  openSpotId: number;
  spotPlayingPath: string;
  videoDialogOpened: boolean;
  openYacastPlayer: boolean;
  mediaIDtoPlay: number;
  currentRowPlaying: number;
  mediaNametoPlay: string;
  startDatetoPlay: number;
  endDatetoPlay: number;
  isRegionPlaying: boolean;
  filmIdLabel: string;
  isPlayerOpen: boolean;
  startDateBroadcast: Date;
  endDateBroadcast: Date;
  mediaBroadcast: BroadcastMedia;
  pageSizeBroadcast: number;
  pageBroadcast: number;
  openDetection: boolean;
  detectionTitle: string;
  detectionSubtitle: string;
  detectionStart: number;
  detectionEnd: number;
  detectionMedia: number;
}

interface TablePaginationActionsProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement>,
    newPage: number
  ) => void;
}

export interface DialogTitleProps extends MD.WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
  i18n: I18N;
  layout: any;
  theme: any;
}
const DialogTitle = MD.withTheme(
  MD.withStyles(styles)((props: DialogTitleProps) => {
    const { children, classes, i18n, layout, theme, onClose, ...other } = props;
    return (
      <MuiDialogTitle
        disableTypography
        {...other}
        className={classes.muiDialogTitle}
      >
        <MD.Typography>{children}</MD.Typography>
        {onClose ? (
          <CustomTooltip title={i18n._('Close')}>
            <MD.IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={onClose}
            >
              <CloseRoundedIcon />
            </MD.IconButton>
          </CustomTooltip>
        ) : null}
      </MuiDialogTitle>
    );
  })
);

const TablePagination = withStyles({
  toolbar: {
    padding: 0,
  },
  caption: {
    fontWeight: 300,
  },
  select: {
    fontWeight: 300,
  },
})(MuiTablePagination);

const TableCellDense = withStyles((theme) => ({
  root: {
    padding: '0',

    fontWeight: 300,
    border: 'none',
    textAlign: 'center',
    color: theme.palette.text.primary,
  },
}))(MuiTableCell);

const TableHeaderCellDense = withStyles((theme) => ({
  root: {
    padding: '0',

    fontWeight: 300,
    border: 'none',
    textAlign: 'center',
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.secondary,
  },
}))(MuiTableCell);

const PagintaionIconButton = styled(IconButton)`
   {
    padding: 3px;
  }
`;

export class DetailsRadioContentComponent extends React.Component<
  AllProps,
  IState
> {
  private player: any;

  public constructor(props: AllProps) {
    super(props);
    const currentDate = new Date();
    const currentStart = new Date(1735689600000);
    const currentEnd = new Date(1753363297000);

    this.state = {
      regions: {},
      selectedIndex: -1,
      selectedId: -1,
      idPlaying: -1,
      selectedMaster: null,
      mbAudioInfos: [],
      currentTime: 0,
      openDialogDownloadCSV: false,
      duration: 0,
      progress: 0,
      playbackStatus: 'pause',
      isSeeking: false,
      isLoading: false,
      currentPage: 0,
      endDate: null,
      passages: this.props.spotDetails.broadcastPassages,
      perPage: 100,
      selectedMediaFilter: -1,
      selectedSupportTypeFilter: -1,
      searchInput: null,
      startDate: null,
      totalCount: this.props.spotDetails.broadcastPassagesCount,
      totalPages: 0,
      openReportDialog: false,
      senderEmail: '',
      emailError: '',
      reportComment: '',
      broadcastPlaying: null,
      spotPlayingPath: '',
      openSpotId: -1,
      videoDialogOpened: false,
      openYacastPlayer: false,
      mediaIDtoPlay: -1,
      currentRowPlaying: -1,
      mediaNametoPlay: '',
      startDatetoPlay: -1,
      endDatetoPlay: -1,
      isRegionPlaying: false,
      filmIdLabel: '',
      isPlayerOpen: false,
      startDateBroadcast: currentStart,
      endDateBroadcast: currentEnd,
      mediaBroadcast: { id: -1, name: 'All Medias', count: 0 },
      pageSizeBroadcast: 1000,
      pageBroadcast: 1,
      openDetection: false,
      detectionEnd: 0,
      detectionStart: 0,
      detectionSubtitle: '',
      detectionTitle: '',
      detectionMedia: 0,
    };
  }

  public componentDidMount() {
    this.props.getAdvertisementRadio(this.props.fgpId);
    this.props.getDeclarationStatus(this.props.fgpId, this.props.bucketId);
    if (typeof this.props.search.params.start_date === 'string') {
      this.setState({
        startDateBroadcast: new Date(this.props.search.params.start_date),
      });
    } else {
      this.setState({
        startDateBroadcast: new Date(
          this.props.search.params.start_date.toISOString()
        ),
      });
    }
    if (typeof this.props.search.params.end_date === 'string') {
      this.setState({
        endDateBroadcast: new Date(this.props.search.params.end_date),
      });
    } else {
      this.setState({
        endDateBroadcast: new Date(
          this.props.search.params.end_date.toISOString()
        ),
      });
    }
  }

  public componentDidUpdate(
    prevProps: Readonly<AllProps>,
    prevState: Readonly<IState>,
    snapshot?: any
  ): void {
    if (
      !isNullOrUndefined(this.props.advertisementRadio.result) &&
      prevProps.advertisementRadio.result !==
        this.props.advertisementRadio.result
    ) {
      const broadcastPayload: BroadcastPayload = {
        fgpid: this.props.fgpId,
        bucketid: this.props.bucketId,
        startdate: this.state.startDateBroadcast,
        enddate: this.state.endDateBroadcast,
        params: {
          page_size: this.state.pageSizeBroadcast,
          page: this.state.pageBroadcast,
          order_by: [
            {
              field: 'start_date',
              value: IOrderValue.DESC,
            },
          ],
        },
      };

      this.props.getBroadcast(broadcastPayload);
    }
  }

  private drawAnnouncerProductTitle = (ad: AdRadio) => {
    return (
      <MD.Grid
        container
        direction="row"
        alignItems="center"
        justifyContent="center"
        spacing={2}
      >
        <MD.Grid item>
          <VideocamIcon style={{ fontWeight: 200 }} />
        </MD.Grid>
        <MD.Grid item>
          <MD.Typography
            style={{
              fontWeight: 400,
              textTransform: 'uppercase',
            }}
          >
            {ad.internal_name}
          </MD.Typography>
        </MD.Grid>
        <MD.Grid item>
          <MD.Typography style={{ fontWeight: 300 }}>{ad.title}</MD.Typography>
        </MD.Grid>
      </MD.Grid>
    );
  };

  private drawProductMetadata = (ad: AdRadio) => {
    const { localeInfos } = this.props;
    let locale: string = 'fr';
    if (localeInfos.momentLocale === 'en-us') {
      locale = 'en-us';
    } else if (localeInfos.momentLocale === 'fr') {
      locale = 'fr';
    } else if (localeInfos.momentLocale === 'de') {
      locale = 'en-us';
    }
    Moment.locale(locale);
    const firstBroadcast = ad.first_diffusion
      ? Moment(ad.first_diffusion).format('DD MMM YYYY HH:mm')
      : 'INCONNU';
    const duration = ad.duration;
    return (
      <MD.Table size="small">
        <MD.TableHead>
          <MD.TableRow>
            <TableHeaderCellDense>
              {this.props.i18n._('Duration')}
            </TableHeaderCellDense>
            <TableHeaderCellDense>
              {this.props.i18n._('1st broadcast')}
            </TableHeaderCellDense>
            <TableHeaderCellDense>
              {this.props.i18n._('Announcer')}
            </TableHeaderCellDense>
          </MD.TableRow>
        </MD.TableHead>
        <MD.TableBody>
          <MD.TableRow>
            <TableCellDense>{duration}</TableCellDense>
            <TableCellDense>{firstBroadcast}</TableCellDense>
            <TableCellDense>{ad.advertiser_name}</TableCellDense>
          </MD.TableRow>
        </MD.TableBody>
      </MD.Table>
    );
  };

  private displayDeclarationStatus = (
    item: IFormulaireFranceState | IFormulaireGemaState
  ) => {
    if (item.validation_state) {
      if (item.validation_state.code > 0) {
        return (
          <MD.Tooltip
            title={item.validation_state ? item.validation_state.message : ''}
          >
            <ErrorOutlineIcon color="error" />
          </MD.Tooltip>
        );
      }
    }
    if (item.is_validated) {
      return <DoneOutlineIcon color="primary" />;
    } else {
      return <EditIcon color="primary" />;
    }
  };

  private drawContentPlayer = (ad: AdRadio) => {
    return (
      <MD.Grid>
        <PlayerMaster
          autoplay={false}
          isVideo={false}
          url={`https://streamer.yacast.fr/v0/public/s3?fileType=kantar&fileId=${ad.id}`}
        />
      </MD.Grid>
    );
  };

  private drawDescriptionFooter = (ad: AdRadio) => {
    return (
      <MD.Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        item
        xs={12}
      >
        <MD.Grid item style={{ paddingLeft: '10px' }}></MD.Grid>
        <MD.Grid item>
          <MD.IconButton
            onClick={async () => {
              try {
                // Call the backend to generate a temporary link
                const response = await fetch(
                  `${Config.backendAPIURL}/file/generate_link_radio/${ad.id}`,
                  {
                    method: 'GET',
                    headers: {
                      Authorization: `Bearer ${this.props.user.token}`,
                      'Content-Type': 'application/json',
                    },
                  }
                );

                if (response.ok) {
                  const data = await response.json();
                  const tempLink = `${Config.backendAPIURL}/${data.temporary_link}`;

                  // Open the temporary link in a new tab
                  window.open(tempLink, '_blank');
                } else {
                  console.error(
                    'Failed to generate temporary link:',
                    response.statusText
                  );
                }
              } catch (error) {
                console.error(
                  'An error occurred while generating the temporary link:',
                  error
                );
              }
            }}
          >
            <GetAppIcon />
          </MD.IconButton>
        </MD.Grid>
      </MD.Grid>
    );
  };

  private drawProductDetails = (adResult: AdvertisementRadioResult) => {
    return (
      <MD.Grid item xs={12}>
        <MD.Paper>
          <MD.Grid item xs={12} container direction="column">
            <MD.Grid item xs={12}>
              {this.drawAnnouncerProductTitle(adResult.ad)}
            </MD.Grid>
            <MD.Grid item xs={12}>
              {this.drawProductMetadata(adResult.ad)}
            </MD.Grid>
            <MD.Grid
              item
              xs={12}
              style={{
                maxWidth: '100%',
                width: '100%',
                height: '100%',
                padding: theme.spacing(2),
              }}
            >
              {this.drawContentPlayer(adResult.ad)}
            </MD.Grid>
            <MD.Grid item xs={12}>
              {this.drawDescriptionFooter(adResult.ad)}
            </MD.Grid>
          </MD.Grid>
        </MD.Paper>
      </MD.Grid>
    );
  };

  private drawMediaFilter = (medias: BroadcastMedia[]) => {
    const { classes } = this.props;
    if (medias.length === 0) {
      return <></>;
    }
    const mediaList = medias.sort((a, b) => a.name.localeCompare(b.name));
    let mediasArray: BroadcastMedia[];
    if (mediaList.length > 1) {
      mediasArray = [
        mediaList.reduceRight((previousValue, current) => {
          return {
            id: -1,
            name: this.props.i18n._('Tous les medias'),
            count: previousValue.count + current.count,
          };
        }),
        ...medias,
      ];
    } else {
      mediasArray = [
        ...mediaList,
        {
          id: -1,
          name: this.props.i18n._('Tous les medias'),
          count: mediaList[0].count,
        },
      ];
    }
    if (mediasArray.length === 1) {
      return (
        <MD.FormControl style={{ minWidth: '220px', marginBottom: '-14px' }}>
          <MD.InputLabel
            shrink
            htmlFor="media-native"
            style={{ fontWeight: 300 }}
          >
            {this.props.i18n._(`Media ${medias[0].name} (${medias[0].count})`)}
          </MD.InputLabel>
        </MD.FormControl>
      );
    }

    return (
      <MD.FormControl style={{ minWidth: '220px', marginBottom: '-14px' }}>
        <MD.InputLabel
          shrink
          htmlFor="media-native"
          style={{ fontWeight: 300 }}
        >
          {this.props.i18n._('Media')}
        </MD.InputLabel>
        <MD.NativeSelect
          onChange={(ev: React.ChangeEvent<HTMLSelectElement> | undefined) => {
            if (ev === undefined) {
              return;
            }
            const newValue = mediasArray.find(
              (v) => v.id === parseInt(ev.target.value)
            );
            if (newValue) {
              this.setState({
                mediaBroadcast: newValue,
                pageBroadcast: 1,
              });

              const broadcastPayload: BroadcastPayload = {
                fgpid: this.props.fgpId,
                bucketid: this.props.bucketId,
                startdate: this.state.startDateBroadcast,
                enddate: this.state.endDateBroadcast,
                params: {
                  page_size: this.state.pageSizeBroadcast,
                  page: 1,
                  order_by: [
                    {
                      field: 'start_date',
                      value: IOrderValue.DESC,
                    },
                  ],
                },
              };

              if (newValue.id !== -1) {
                broadcastPayload.media_ids = [newValue.id];
              }

              this.props.getBroadcast(broadcastPayload);
            }
            return;
          }}
          classes={{ select: classes.inputStyles }}
          inputProps={{
            name: 'media-selection',
            id: 'media-selection',
          }}
        >
          {mediasArray.map((media: BroadcastMedia) => (
            <option key={media.id} value={media.id}>
              {media.name + '(' + media.count + ')'}
            </option>
          ))}
        </MD.NativeSelect>
        <MD.FormHelperText style={{ fontWeight: 300 }}>
          {this.props.i18n._('Filtrer par média')}
        </MD.FormHelperText>
      </MD.FormControl>
    );
  };

  private drawMediaBroadcastFilters(medias?: BroadcastMedia[]) {
    return (
      <MD.Grid
        container
        alignItems="center"
        justifyContent="space-between"
        style={{ marginBottom: '13px' }}
        direction="row"
      >
        <MD.Grid item>{this.drawDatePickers()}</MD.Grid>
        <MD.Grid item>{medias && this.drawMediaFilter(medias)}</MD.Grid>
        <MD.Grid item>
          {hasPermissionExportPassages(this.props.user) &&
            this.drawMediaBroadcastToolbar()}
        </MD.Grid>
      </MD.Grid>
    );
  }

  private onStartDateChange = (date: MaterialUiPickersDate) => {
    this.setState({
      startDateBroadcast: date,
      pageBroadcast: 1,
    });
    const broadcastPayload: BroadcastPayload = {
      fgpid: this.props.fgpId,
      bucketid: this.props.bucketId,
      startdate: date,
      enddate: this.state.endDateBroadcast,
      params: {
        page_size: this.state.pageSizeBroadcast,
        page: 1,
        order_by: [
          {
            field: 'start_date',
            value: IOrderValue.DESC,
          },
        ],
      },
    };

    if (this.state.mediaBroadcast.id !== -1) {
      broadcastPayload.media_ids = [this.state.mediaBroadcast.id];
    }

    this.props.getBroadcast(broadcastPayload);
  };

  private onEndDateChange = (date: MaterialUiPickersDate) => {
    this.setState({
      endDateBroadcast: date,
      pageBroadcast: 1,
    });
    const broadcastPayload: BroadcastPayload = {
      fgpid: this.props.fgpId,
      bucketid: this.props.bucketId,
      startdate: this.state.startDateBroadcast,
      enddate: date,
      params: {
        page_size: this.state.pageSizeBroadcast,
        page: 1,
        order_by: [
          {
            field: 'start_date',
            value: IOrderValue.DESC,
          },
        ],
      },
    };

    if (this.state.mediaBroadcast.id !== -1) {
      broadcastPayload.media_ids = [this.state.mediaBroadcast.id];
    }

    this.props.getBroadcast(broadcastPayload);
  };

  private drawDatePickers = () => {
    const { classes, localeInfos } = this.props;
    let startDate = this.state.startDateBroadcast;
    let endDate = this.state.endDateBroadcast;
    let format: string = '',
      locale: Locale = fr;
    if (localeInfos.momentLocale === 'en-us') {
      format = 'MM/dd/yyyy';
      locale = enGB;
    } else if (localeInfos.momentLocale === 'fr') {
      format = 'dd/MM/yyyy';
      locale = fr;
    } else if (localeInfos.momentLocale === 'de') {
      format = 'dd/MM/yyyy';
      locale = de;
    }
    return (
      <MD.FormControl>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
          <MD.Grid
            container
            justifyContent="center"
            alignItems="center"
            direction="row"
          >
            <MD.Grid item xs={6}>
              <DatePicker
                style={{
                  borderBottom: 'outset',
                  borderBottomWidth: '1px',
                  marginRight: '10px',
                }}
                autoOk={true}
                disableToolbar
                variant="inline"
                format={format}
                className={classes.datePickerInput}
                id="start-date-picker"
                label={this.props.i18n._('From')}
                value={startDate}
                onChange={this.onStartDateChange.bind(this)}
                InputProps={{ disableUnderline: true }}
                InputLabelProps={{ className: classes.datePickerLabel }}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    //   this.handleSearch();
                  }
                }}
              />
            </MD.Grid>
            <MD.Grid item xs={6}>
              <MD.Grid item>
                <DatePicker
                  style={{
                    marginLeft: '10px',
                    borderBottom: 'outset',
                    borderBottomWidth: '1px',
                  }}
                  disableToolbar
                  variant="inline"
                  format={format}
                  className={classes.datePickerInput}
                  id="end_date_picker"
                  label={this.props.i18n._('To')}
                  value={endDate}
                  onChange={this.onEndDateChange.bind(this)}
                  //disableFuture={true}
                  autoOk={true}
                  InputProps={{ disableUnderline: true }}
                  InputLabelProps={{ className: classes.datePickerLabel }}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      //   this.handleSearch();
                    }
                  }}
                />
              </MD.Grid>
            </MD.Grid>
          </MD.Grid>
        </MuiPickersUtilsProvider>
      </MD.FormControl>
    );
  };

  private openDialogDownloadCSV() {
    const { i18n, spotDetails } = this.props;
    return (
      <MD.Dialog
        aria-labelledby="draggable-title"
        onClose={this.handleCloseDownloadCSV.bind(this)}
        open={this.state.openDialogDownloadCSV}
        PaperComponent={PaperComponent}
      >
        <DialogTitle
          i18n={this.props.i18n}
          layout={this.props.layout}
          theme={theme}
          id="draggable-title"
          onClose={this.handleCloseDownloadCSV.bind(this)}
        >
          Export CSV
        </DialogTitle>
        <MD.DialogContent className={this.props.classes.dialogContent} dividers>
          {spotDetails.file_downloaded === null ? (
            <MD.Typography
              gutterBottom
              className={this.props.classes.containerDivText}
            >
              {i18n._('Loading')}...
            </MD.Typography>
          ) : (
            <MD.Typography
              gutterBottom
              className={this.props.classes.containerDivText}
            >
              {i18n._('téléchargement terminé !')}
            </MD.Typography>
          )}
        </MD.DialogContent>
      </MD.Dialog>
    );
  }

  private handleClickDownloadCSV() {
    const broadcastPayload: BroadcastPayload = {
      fgpid: this.props.fgpId,
      bucketid: this.props.bucketId,
      startdate: this.state.startDateBroadcast,
      enddate: this.state.endDateBroadcast,
      params: {
        page_size: this.state.pageSizeBroadcast,
        page: this.state.pageBroadcast,
        order_by: [
          {
            field: 'start_date',
            value: IOrderValue.DESC,
          },
        ],
      },
    };
    this.props.getCSV(broadcastPayload);
  }
  private drawMediaBroadcastToolbar = () => {
    return (
      <MD.Grid
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="flex-end"
        style={{ marginTop: '-4px', marginBottom: '-6px' }}
      >
        <MD.Grid item>
          <ButtonDense
            variant="outlined"
            onClick={() => this.handleClickDownloadCSV()}
          >
            <span style={{ color: theme.palette.text.secondary }}>CSV</span>
          </ButtonDense>
        </MD.Grid>
      </MD.Grid>
    );
  };

  public tablePaginationActions = (props: TablePaginationActionsProps) => {
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (
      event: React.MouseEvent<HTMLButtonElement>
    ) => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = (
      event: React.MouseEvent<HTMLButtonElement>
    ) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (
      event: React.MouseEvent<HTMLButtonElement>
    ) => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (
      event: React.MouseEvent<HTMLButtonElement>
    ) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <div style={{ marginLeft: '0px', flexShrink: 0 }}>
        <PagintaionIconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
        </PagintaionIconButton>
        <PagintaionIconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === 'rtl' ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </PagintaionIconButton>
        <PagintaionIconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === 'rtl' ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </PagintaionIconButton>
        <PagintaionIconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
        </PagintaionIconButton>
      </div>
    );
  };

  private onChangePageResultsTable = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
    page: number
  ) => {
    if (isNaN(page)) {
      return;
    }
    page = page + 1;
    this.setState({ pageBroadcast: page });
    const broadcastPayload: BroadcastPayload = {
      fgpid: this.props.fgpId,
      bucketid: this.props.bucketId,
      startdate: this.state.startDateBroadcast,
      enddate: this.state.endDateBroadcast,
      params: {
        page_size: this.state.pageSizeBroadcast,
        page: page,
        order_by: [
          {
            field: 'start_date',
            value: IOrderValue.DESC,
          },
        ],
      },
    };

    if (this.state.mediaBroadcast.id !== -1) {
      broadcastPayload.media_ids = [this.state.mediaBroadcast.id];
    }

    this.props.getBroadcast(broadcastPayload);
  };

  private onChangeRowsPerPageResultsTable = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const pageSize = parseInt(event.target.value);
    if (isNaN(pageSize)) {
      return;
    }
    this.setState({ pageSizeBroadcast: pageSize });
    const broadcastPayload: BroadcastPayload = {
      fgpid: this.props.fgpId,
      bucketid: this.props.bucketId,
      startdate: this.state.startDateBroadcast,
      enddate: this.state.endDateBroadcast,
      params: {
        page_size: pageSize,
        page: this.state.pageBroadcast,
        order_by: [
          {
            field: 'start_date',
            value: IOrderValue.DESC,
          },
        ],
      },
    };

    if (this.state.mediaBroadcast.id !== -1) {
      broadcastPayload.media_ids = [this.state.mediaBroadcast.id];
    }

    this.props.getBroadcast(broadcastPayload);
  };

  private drawTablePagination = (response: BroadcastResponse) => {
    return (
      <TablePagination
        rowsPerPageOptions={[5, 10, 25, 50, 100, 1000]}
        labelRowsPerPage={this.props.i18n._('Rows per page')}
        count={response.total_count}
        rowsPerPage={this.state.pageSizeBroadcast}
        page={this.state.pageBroadcast - 1}
        onPageChange={this.onChangePageResultsTable}
        onRowsPerPageChange={this.onChangeRowsPerPageResultsTable}
        ActionsComponent={this.tablePaginationActions}
      />
    );
  };

  private drawMediaBroadcastTable = (response: BroadcastResponse) => {
    return (
      <>
        <MD.Table>
          <MD.TableHead>
            <MD.TableRow>{this.drawTablePagination(response)}</MD.TableRow>
          </MD.TableHead>
        </MD.Table>
        <MD.TableContainer component={MD.Paper} style={{ maxHeight: '400px' }}>
          <MD.Table stickyHeader size="small">
            <MD.TableHead>
              <MD.TableRow>
                <MD.TableCell
                  size={'small'}
                  style={{
                    textTransform: 'capitalize',
                    textAlign: 'left',
                    backgroundColor: theme.palette.background.paper,
                  }}
                >
                  {this.props.i18n._('Media')}
                </MD.TableCell>
                <MD.TableCell
                  size={'small'}
                  style={{
                    textTransform: 'capitalize',
                    textAlign: 'left',
                    backgroundColor: theme.palette.background.paper,
                  }}
                >
                  {this.props.i18n._('Detection start')}
                </MD.TableCell>
                <MD.TableCell
                  size={'small'}
                  style={{
                    textTransform: 'capitalize',
                    textAlign: 'left',
                    backgroundColor: theme.palette.background.paper,
                  }}
                >
                  {this.props.i18n._('Detection end')}
                </MD.TableCell>
                <MD.TableCell
                  size={'small'}
                  style={{
                    textTransform: 'capitalize',
                    textAlign: 'left',
                    backgroundColor: theme.palette.background.paper,
                  }}
                >
                  {this.props.i18n._('Play detection')}
                </MD.TableCell>
              </MD.TableRow>
            </MD.TableHead>
            <MD.TableBody>
              {response.results.map((v, i) => {
                return (
                  <MD.TableRow key={`${v.id}_${i}`}>
                    <MD.TableCell size={'small'}>{v.media.name}</MD.TableCell>
                    <MD.TableCell size={'small'}>
                      {new Date(v.start_date + 'Z').toLocaleString()}
                    </MD.TableCell>
                    <MD.TableCell size={'small'}>
                      {new Date(v.end_date + 'Z').toLocaleString()}
                    </MD.TableCell>
                    <MD.TableCell size={'small'}>
                      <MD.IconButton
                        style={{
                          padding: 0,
                        }}
                        onClick={(event: any) => {
                          event.stopPropagation();
                          this.handleShowVideoDetection(v);
                        }}
                      >
                        <PlayCircleFilledIcon
                          className={this.props.classes.iconStyle}
                          color="secondary"
                        />
                      </MD.IconButton>
                    </MD.TableCell>
                  </MD.TableRow>
                );
              })}
              {response.results.length === 0 && (
                <MD.TableCell colSpan={4} size={'small'} style={{ padding: 0 }}>
                  <Alert
                    severity={'warning'}
                    style={{ backgroundColor: theme.palette.background.paper }}
                  >
                    Pas de résultats pour la période demandée
                  </Alert>
                </MD.TableCell>
              )}
            </MD.TableBody>
          </MD.Table>
        </MD.TableContainer>
      </>
    );
  };

  private drawBroadcastsDetails = () => {
    const { response, isLoading, error, previousResponse } =
      this.props.broadcast;
    if (isLoading && !!!previousResponse) {
      return <>Loading...</>;
    }
    if (isLoading) {
      if (!previousResponse) {
        return <>An error occurred</>;
      } else {
        return (
          <>{this.drawBroadcastsDetailsFromResponse(previousResponse, true)}</>
        );
      }
    }
    if (error !== '') {
      return <>{error} error</>;
    }
    if (!response) {
      return <>An error occurred</>;
    } else {
      return this.drawBroadcastsDetailsFromResponse(response, false);
    }
  };

  private drawBroadcastsDetailsFromResponse = (
    response: BroadcastResponse,
    isLoading: boolean
  ) => {
    if (
      response.results.length > 0 &&
      response.results.every((v) => !!v.no_diffusion)
    ) {
      return <></>;
    }
    return (
      <MD.Grid item xs={12}>
        <MD.Paper>
          <MD.Grid item>
            {this.drawMediaBroadcastFilters(response.medias)}
          </MD.Grid>
          {isLoading && <MD.LinearProgress style={{ width: '100%' }} />}
          <MD.Grid item>{this.drawMediaBroadcastTable(response)}</MD.Grid>
        </MD.Paper>
      </MD.Grid>
    );
  };

  private handleCloseDownloadCSV = () => {
    this.setState({
      openDialogDownloadCSV: false,
    });
  };

  private drawIdenticSpotDetails = (adResult: AdvertisementRadioResult) => {
    return (
      <MD.Grid item xs={12}>
        <MD.Paper>
          <MD.Typography
            variant="h6"
            component="h1"
            color="secondary"
            style={{ margin: '0 16px', padding: '16px 0' }}
          >
            {this.props.i18n._('Regroupement spots synchro musicale identique')}
          </MD.Typography>
          <MD.TableContainer
            component={MD.Paper}
            style={{ maxHeight: '400px' }}
          >
            <MD.Table stickyHeader size="small">
              <MD.TableHead>
                <MD.TableRow>
                  <MD.TableCell
                    size="small"
                    style={{
                      textAlign: 'left',
                      backgroundColor: theme.palette.background.paper,
                    }}
                  >
                    {this.props.i18n._('id')}
                  </MD.TableCell>
                  <MD.TableCell
                    size="small"
                    style={{
                      textAlign: 'left',
                      backgroundColor: theme.palette.background.paper,
                    }}
                  >
                    {this.props.i18n._('Unique identifier')}
                  </MD.TableCell>
                  <MD.TableCell
                    size="small"
                    style={{
                      textAlign: 'left',
                      backgroundColor: theme.palette.background.paper,
                    }}
                  >
                    {this.props.i18n._('Play spot')}
                  </MD.TableCell>
                </MD.TableRow>
              </MD.TableHead>
              <MD.TableBody>
                {adResult.group_ads.map((ad: GroupAdRadio, index: number) => {
                  return (
                    <MD.TableRow key={'identic' + index}>
                      <MD.TableCell
                        size="small"
                        style={{ textAlign: 'left', color: '#C4C4C4' }}
                      >
                        {ad.id}
                      </MD.TableCell>
                      <MD.TableCell
                        size="small"
                        style={{ textAlign: 'left', color: '#C4C4C4' }}
                      >
                        {ad.id}
                      </MD.TableCell>
                      <MD.TableCell align="left">
                        <MD.IconButton
                          style={{
                            padding: 0,
                          }}
                          onClick={(event: any) => {
                            event.stopPropagation();
                            this.handleShowVideoPlayerClick(`${ad.id}`);
                          }}
                        >
                          <PlayCircleFilledIcon
                            className={this.props.classes.iconStyle}
                            color="secondary"
                          />
                        </MD.IconButton>
                      </MD.TableCell>
                    </MD.TableRow>
                  );
                })}
              </MD.TableBody>
            </MD.Table>
          </MD.TableContainer>
        </MD.Paper>
      </MD.Grid>
    );
  };

  private drawMusicSpotDetails = (adResult: AdvertisementRadioResult) => {
    return (
      <MD.Grid
        container
        item
        xs={12}
        style={{
          width: '100%',
        }}
      >
        <MD.Paper
          style={{
            width: '100%',
          }}
        >
          <MD.Typography
            variant="h6"
            component="h1"
            color="secondary"
            style={{ margin: '0 16px', padding: '16px 0' }}
          >
            {this.props.i18n._('Synchro musicale (réservé abonnés Mytrack)')}
          </MD.Typography>
          <MD.Table size="small">
            <MD.TableHead>
              <MD.TableRow>
                <MD.TableCell size="small" style={{ textAlign: 'left' }}>
                  {this.props.i18n._('Source')}
                </MD.TableCell>
                <MD.TableCell size="small" style={{ textAlign: 'left' }}>
                  {this.props.i18n._('Title')}
                </MD.TableCell>
                <MD.TableCell size="small" style={{ textAlign: 'left' }}>
                  {this.props.i18n._('Authors')}
                </MD.TableCell>
                <MD.TableCell size="small" style={{ textAlign: 'left' }}>
                  {this.props.i18n._('Compositors')}
                </MD.TableCell>
              </MD.TableRow>
            </MD.TableHead>
            <MD.TableBody>
              {adResult.tracks.map((track: TrackRadio, index: number) => {
                return (
                  <MD.TableRow key={'track' + index}>
                    <MD.TableCell size="small" style={{ textAlign: 'left' }}>
                      {track.source.toUpperCase()}
                    </MD.TableCell>
                    <MD.TableCell size="small" style={{ textAlign: 'left' }}>
                      {track.title}
                    </MD.TableCell>
                    <MD.TableCell size="small" style={{ textAlign: 'left' }}>
                      {track.authors}
                    </MD.TableCell>
                    <MD.TableCell size="small" style={{ textAlign: 'left' }}>
                      {track.composers}
                    </MD.TableCell>
                  </MD.TableRow>
                );
              })}
            </MD.TableBody>
          </MD.Table>
          <MD.Grid item xs={12}>
            <Alert
              severity="info"
              style={{ backgroundColor: theme.palette.background.paper }}
            >
              {this.props.i18n._(
                'Mentionner la durée musicale dans votre déclaration'
              )}
            </Alert>
          </MD.Grid>
        </MD.Paper>
      </MD.Grid>
    );
  };

  private handleShowVideoPlayerClick = (id: string) => {
    this.setState({
      isPlayerOpen: true,
      filmIdLabel: id,
    });
  };

  private handleShowVideoDetection = (broadcast: BroadcastResult) => {
    this.setState({
      openDetection: true,
      detectionEnd: Math.ceil(
        new Date(broadcast.end_date + 'Z').getTime() / 1000
      ),
      detectionStart: Math.floor(
        new Date(broadcast.start_date + 'Z').getTime() / 1000
      ),
      detectionMedia: broadcast.media.id,
      detectionSubtitle:
        this.props.advertisementRadio.result?.ad.internal_name || '',
      detectionTitle: this.props.advertisementRadio.result?.ad.title || '',
    });
  };

  private PlayerDialog = () => {
    if (this.state.filmIdLabel === '') {
      return <></>;
    }

    return (
      <MD.Dialog
        fullWidth
        open={this.state.isPlayerOpen}
        onClose={() =>
          this.setState({
            isPlayerOpen: false,
            filmIdLabel: '',
          })
        }
      >
        <MD.DialogContent>
          <PlayerMaster
            autoplay={false}
            isVideo={false}
            url={`https://streamer.yacast.fr/v0/public/s3?fileType=kantar&fileId=${this.state.filmIdLabel}`}
          />
        </MD.DialogContent>
      </MD.Dialog>
    );
  };

  private PlayerDialogBroadcast = () => {
    if (
      this.state.detectionMedia === 0 ||
      this.state.detectionStart === 0 ||
      this.state.detectionEnd === 0
    ) {
      return <></>;
    }

    return (
      <MD.Dialog
        fullWidth
        open={this.state.openDetection}
        onClose={() =>
          this.setState({
            openDetection: false,
            detectionEnd: 0,
            detectionStart: 0,
            detectionMedia: 0,
            detectionSubtitle: '',
            detectionTitle: '',
          })
        }
      >
        <MD.DialogContent>
          <PlayerMaster
            autoplay={false}
            isVideo={false}
            url={`https://streamer.yacast.fr/v0/public/instant?media=${this.state.detectionMedia}&start=${this.state.detectionStart}&end=${this.state.detectionEnd}`}
          />
        </MD.DialogContent>
      </MD.Dialog>
    );
  };

  private drawFormButtons = () => {
    if (this.props.declarationStatus.isLoading) {
      return (
        <MD.Grid style={{ marginLeft: '20px', padding: '8px' }}>
          <div>{this.props.i18n._('Loading')}...</div>
        </MD.Grid>
      );
    }

    const { response } = this.props.declarationStatus;

    if (
      !response ||
      response.results.length === 0 ||
      response.results.every(
        (f) => f.user_group_id !== this.props.user.userInfo.parent_info.id
      )
    ) {
      return (
        <StyledLink
          to={
            '/formulaire/' +
            this.props.bucketId +
            '/' +
            this.props.fgpId +
            '/' +
            this.props.user.userInfo.parent_info.id
          }
        >
          <ButtonDenseNoColor
            variant="contained"
            color="secondary"
            className={this.props.classes.buttonDense}
            fullWidth
          >
            <AddIcon />
            <InsertDriveFileIcon style={{ marginRight: '5px' }} />
            {this.props.i18n._('Créer un formulaire de déclaration')}
          </ButtonDenseNoColor>
        </StyledLink>
      );
    } else if (response.results.length === 1) {
      return (
        <StyledLink
          to={
            '/formulaire/' +
            this.props.bucketId +
            '/' +
            this.props.fgpId +
            '/' +
            response.results[0].user_group_id
          }
        >
          <ButtonDenseNoColor
            variant="contained"
            color="secondary"
            className={this.props.classes.buttonDense}
            fullWidth
          >
            <AddIcon />
            <InsertDriveFileIcon style={{ marginRight: '5px' }} />
            {response.results[0].user_group_id ===
            this.props.user.userInfo.parent_info.id
              ? this.props.i18n._('Voir ma déclaration')
              : this.props.i18n._('Voir la déclaration du sociétaire')}
          </ButtonDenseNoColor>
        </StyledLink>
      );
    }
  };

  private openReportDialog(ev: any) {
    this.setState({ openReportDialog: true });
  }
  private closeReportDialog() {
    this.setState({
      openReportDialog: false,
      senderEmail: '',
      emailError: '',
      reportComment: '',
    });
  }
  private validateEmail(value: string) {
    let error = '';
    if (value === '') {
      error = this.props.i18n._('This field is required.');
    } else if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value)) {
      error = this.props.i18n._('Email is not valid.');
    }
    this.setState({ emailError: error });
  }
  private formIsValid() {
    const isValid = this.state.emailError === '';
    return isValid;
  }
  private handleSenderEmailChange(ev: any) {
    let value = ev.target.value;
    this.setState({ senderEmail: value });
  }
  private handleVerifySenderEmail(ev: any) {
    let value = ev.target.value;
    this.validateEmail(value);
  }
  private onCommentChange(ev: any) {
    let value = ev.target.value;
    this.setState({ reportComment: value });
  }
  private handleReportFormSubmit() {
    this.closeReportDialog();
    if (this.formIsValid()) {
      const details = this.props.spotDetails.metadatas;
      let product_label = '-',
        title = '-',
        duration: string | number = '-',
        first_broadcast: Moment.Moment | null | string = null,
        advertiser = '-',
        media_name = '-';
      if (details.metadatas) {
        product_label = details.metadatas.product_label;
        title = details.metadatas.title;
        duration = details.metadatas.duration;
        first_broadcast = details.metadatas.first_broadcast;
        advertiser = details.metadatas.advertiser.name;
        media_name = details.media.name;
      }

      const location = window.location.href;

      this.props.reportSpotProblem({
        spot_id: this.props.fgpId,
        email: this.state.senderEmail,
        comment: this.state.reportComment,
        product_label,
        title,
        duration,
        first_broadcast,
        advertiser,
        media_name,
        identic_spots: this.props.spotDetails.identicSpots,
        spot_link: location,
      });
    }
  }
  private drawReportDialog() {
    const { i18n } = this.props;
    return (
      <MD.Dialog open={this.state.openReportDialog}>
        <MD.DialogTitle>
          {this.props.i18n._('Report problem with spot')}{' '}
          {`${this.props.fgpId}`}
        </MD.DialogTitle>
        <MD.DialogContent>
          <MD.DialogContentText>
            {this.props.i18n._(
              'To report a problem with this spot, please enter your email address here and indicate the nature of the problem in the comment field.'
            )}
          </MD.DialogContentText>
          <MD.TextField
            autoFocus
            margin="dense"
            id="email"
            label={this.props.i18n._('Email Address')}
            type="email"
            fullWidth
            variant="outlined"
            onBlur={this.handleVerifySenderEmail.bind(this)}
            onChange={this.handleSenderEmailChange.bind(this)}
            helperText={this.state.emailError}
            error={this.state.emailError !== ''}
          />
          <MD.TextField
            margin="dense"
            label={this.props.i18n._('Comments')}
            value={this.state.reportComment}
            fullWidth
            id="comment"
            type="search"
            multiline
            maxRows={5}
            variant="outlined"
            onChange={this.onCommentChange.bind(this)}
          />
        </MD.DialogContent>
        <MD.DialogActions>
          <MD.Button onClick={this.closeReportDialog.bind(this)}>
            {i18n._('Cancel')}
          </MD.Button>
          <MD.Button
            onClick={this.handleReportFormSubmit.bind(this)}
            disabled={!this.formIsValid()}
          >
            {i18n._('Send')}
          </MD.Button>
        </MD.DialogActions>
      </MD.Dialog>
    );
  }

  private drawReportButtons() {
    return (
      <>
        {this.drawReportDialog()}
        <ButtonDenseNoColor
          variant="contained"
          color="secondary"
          onClick={this.openReportDialog.bind(this)}
          className={this.props.classes.buttonDense}
          fullWidth
        >
          <MD.Typography variant="body2" align="center">
            {this.props.i18n._('Report Spot')}
          </MD.Typography>
        </ButtonDenseNoColor>
      </>
    );
  }
  private drawButtons() {
    return (
      <>
        <MD.Grid item xs={6}>
          {this.drawFormButtons()}
        </MD.Grid>
        <MD.Grid item xs={6}>
          {this.drawReportButtons()}
        </MD.Grid>
      </>
    );
  }

  private TableDeclaration(response: ResponseDeclarationStatus) {
    const { results } = response;
    if (!results || results.length <= 1) return <></>;
    return (
      <MD.Grid item xs={12}>
        <MD.Paper>
          <MD.TableContainer
            component={MD.Paper}
            style={{ maxHeight: '400px' }}
          >
            <MD.Table stickyHeader size="small">
              <MD.TableHead>
                <MD.TableRow>
                  <MD.TableCell>ID Société</MD.TableCell>
                  <MD.TableCell>Status</MD.TableCell>
                  <MD.TableCell>Création</MD.TableCell>
                  <MD.TableCell>Dernière modification</MD.TableCell>
                  <MD.TableCell>Lien</MD.TableCell>
                </MD.TableRow>
              </MD.TableHead>
              <MD.TableBody>
                {results.map((v) => {
                  return (
                    <MD.TableRow>
                      <MD.TableCell>{v.user_group_id}</MD.TableCell>
                      <MD.TableCell>
                        {v.signature_status || 'draft'}
                      </MD.TableCell>
                      <MD.TableCell>{v.created_at}</MD.TableCell>
                      <MD.TableCell>{v.last_modified}</MD.TableCell>
                      <MD.TableCell>
                        <StyledLink
                          to={
                            '/formulaire/' +
                            this.props.bucketId +
                            '/' +
                            this.props.fgpId +
                            '/' +
                            v.user_group_id
                          }
                        >
                          <MD.IconButton style={{ padding: '2px' }}>
                            <InsertDriveFileIcon
                              color="secondary"
                              className={this.props.classes.detailsIcon}
                            />
                          </MD.IconButton>
                        </StyledLink>
                      </MD.TableCell>
                    </MD.TableRow>
                  );
                })}
              </MD.TableBody>
            </MD.Table>
          </MD.TableContainer>
        </MD.Paper>
      </MD.Grid>
    );
  }

  private displayContent(adResult: AdvertisementRadioResult): React.ReactNode {
    return (
      <MD.Container
        style={{
          overflowY: 'auto',
          overflowX: 'hidden',
          height: `calc(100vh - ${
            theme.Adtrack.dimensions.appBarHeight + theme.spacing(2)
          }px)`,
          width: '100%',
          maxWidth: '100%',
        }}
        maxWidth={'xl'}
      >
        <MD.Grid container direction="row" spacing={2} item xs={12}>
          <MD.Grid
            container
            item
            xs={12}
            md={6}
            lg={5}
            xl={4}
            spacing={2}
            style={{ height: 'fit-content' }}
          >
            {this.drawProductDetails(adResult)}
            {(this.props.user.userInfo.parent_info.id === 2 ||
              this.props.user.userInfo.parent_info.id === 152) &&
              adResult.tracks.length > 0 &&
              this.drawMusicSpotDetails(adResult)}
          </MD.Grid>
          <MD.Grid
            container
            item
            xs={12}
            md={6}
            lg={7}
            xl={8}
            spacing={2}
            style={{ height: 'fit-content' }}
          >
            {this.drawButtons()}
            {this.props.declarationStatus.response &&
              this.TableDeclaration(this.props.declarationStatus.response)}
            {this.drawIdenticSpotDetails(adResult)}
            {hasPermissionMediaPassagesToRead(this.props.user)
              ? this.drawBroadcastsDetails()
              : null}
          </MD.Grid>
          {this.PlayerDialog()}
          {this.PlayerDialogBroadcast()}
          {this.openDialogDownloadCSV()}
        </MD.Grid>
      </MD.Container>
    );
  }

  public render(): React.ReactNode {
    return this.props.advertisementRadio.isLoading ? (
      <>Loading...</>
    ) : this.props.advertisementRadio.error !== '' ? (
      <>An error occured</>
    ) : this.props.advertisementRadio.result ? (
      this.displayContent(this.props.advertisementRadio.result)
    ) : (
      <>An error occured</>
    );
  }
}

const mapStateToProps = (
  {
    i18n,
    search,
    spotDetails,
    user,
    layout,
    advertisementRadio,
    broadcast,
    declarationStatus,
  }: IApplicationState,
  ownProps: RouteComponentProps<RouteParams>
) => {
  // Extract bucket and fgpid from the route parameters and convert them to numbers
  const bucketId = parseInt(ownProps.match.params.bucket, 10);
  const fgpId = parseInt(ownProps.match.params.fgpid, 10);

  return {
    i18n: i18n.i18n,
    localeInfos: i18n.localeInfos,
    router: ownProps,
    search,
    spotDetails,
    user,
    layout,
    advertisementRadio,
    bucketId,
    fgpId,
    broadcast,
    declarationStatus,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getSpotFormulaires: (fgpBucketPair: IFingerprintBucketPair[]) =>
    dispatch(getSpotFormulaires(fgpBucketPair)),
  getBroadcastsPassages: (
    fgpBucketPair: IFingerprintBucketPair[],
    startDate: Moment.Moment,
    endDate: Moment.Moment
  ) => dispatch(getBroadcastsPassages(fgpBucketPair, startDate, endDate)),
  getBroadcastsPassagesByFgpID: (
    fgpid: number,
    bucket_id: number,
    startDate: Moment.Moment,
    endDate: Moment.Moment,
    params: IPaginationParams,
    media_id?: number[]
  ) =>
    dispatch(
      getBroadcastsPassagesByFgpID(
        fgpid,
        bucket_id,
        startDate,
        endDate,
        params,
        media_id
      )
    ),
  getBroadcastWebPassages: (
    startDate: Moment.Moment,
    endDate: Moment.Moment,
    group_id: number | undefined,
    page: number,
    limit: number
  ) =>
    dispatch(
      getBroadcastWebPassages(startDate, endDate, group_id, page, limit)
    ),
  getFormulairePreview: (
    regroupingId: string,
    bucketId: number,
    spotId: number,
    fingerprint_list: IFingerprintBucketPair[]
  ) =>
    dispatch(
      getFormulairePreview(regroupingId, bucketId, spotId, fingerprint_list)
    ),
  getSpotDetails: (bucketId: number, spotId: number) =>
    dispatch(getSpotDetails(bucketId, spotId)),
  downloadCSV: (startDate: Moment.Moment, endDate: Moment.Moment) =>
    dispatch(downloadCSV(startDate, endDate)),
  reportSpotProblem: (params: IReportSpotDetails) =>
    dispatch(reportSpotProblem(params)),
  getAdvertisementRadio: (id: number) => dispatch(getAdvertisementRadio(id)),
  getBroadcast: (payload: BroadcastPayload) => dispatch(getBroadcast(payload)),
  getCSV: (payload: BroadcastPayload) => dispatch(getCSV(payload)),
  getDeclarationStatus: (reference_ad_id: number, bucket_id: number) =>
    dispatch(getDeclarationStatus(reference_ad_id, bucket_id)),
});

export const DetailsRadioContent = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTheme(withStyles(styles)(DetailsRadioContentComponent)));
